module.exports = __webpack_public_path__ + "img/video.b9c9461d.jpg";